import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0afcf9c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"36px"} }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "price" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px"} }, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"32px"} }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px"} }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "stock" }
const _hoisted_9 = {
  key: 0,
  class: "running-out-of-stock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "product-card",
    onMouseover: _cache[4] || (_cache[4] = ($event: any) => ($setup.isHovered = true)),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => ($setup.isHovered = false)),
    style: _normalizeStyle({
      transform: $setup.isHovered ? 'scale(1.05)' : 'scale(1.0)'
    })
  }, [
    ($setup.photoUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $setup.photoUrl,
          alt: "Product image",
          class: "image",
          style: _normalizeStyle({
        transform: $setup.isHovered ? 'scale(1.15)' : 'scale(1.0)'
      })
        }, null, 12 /* STYLE, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, "R$ " + _toDisplayString($setup.FormatUtils.formatPrice($props.product.b2b_price)), 1 /* TEXT */),
    _hoisted_4,
    _createElementVNode("p", _hoisted_5, _toDisplayString($props.product.name), 1 /* TEXT */),
    _hoisted_6,
    _createVNode($setup["ExpiresCard"], {
      expiresAt: $props.product.getNextExpiresAt()
    }, null, 8 /* PROPS */, ["expiresAt"]),
    _hoisted_7,
    _createElementVNode("div", {
      class: "stock-info",
      style: _normalizeStyle({
      marginBottom: $setup.isHovered ? 'initial' : '-60px',
    })
    }, [
      _createElementVNode("p", _hoisted_8, "Estoque: " + _toDisplayString($props.product.stock_info.total_stock) + " un.", 1 /* TEXT */),
      ($props.product.isRunningOutOfStock())
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "ACABANDO"))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    _createElementVNode("p", {
      class: "stock show-data-animation",
      style: _normalizeStyle({
      pointerEvents: $setup.isHovered ? 'auto' : 'none',
      animation: $setup.isHovered ? 'show-card-data 1s forwards' : 'none',
    })
    }, "Un. por caixa: " + _toDisplayString($props.product.getUnitsPerPackage()), 5 /* TEXT, STYLE */),
    _createElementVNode("p", {
      class: "stock show-data-animation",
      style: _normalizeStyle({
      pointerEvents: $setup.isHovered ? 'auto' : 'none',
      animation: $setup.isHovered ? 'show-card-data 1s forwards' : 'none',
    })
    }, "Total de caixas: " + _toDisplayString($props.product.getTotalPackages()), 5 /* TEXT, STYLE */),
    (($props.amountInCart || 0) <= 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "add-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-to-cart', $props.product.getUnitsPerPackage(), $event))),
          style: _normalizeStyle({
        transform: $setup.isHovered ? 'scale(1.15)' : 'scale(1.0)',
      })
        }, [
          _createVNode($setup["FontAwesomeIcon"], {
            icon: $setup.Icons.imported.faPlus
          }, null, 8 /* PROPS */, ["icon"])
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    (($props.amountInCart || 0) > 0)
      ? (_openBlock(), _createBlock($setup["PlusMinus"], {
          key: 2,
          amount: $props.amountInCart ?? 0,
          packageAmount: $props.product.getUnitsPerPackage(),
          stockQuantity: $props.stockQuantity ?? 0,
          onRemoveFromCart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove-from-cart', $event))),
          onSetAmount: _cache[2] || (_cache[2] = (amount, evt) => _ctx.$emit('set-amount', amount, evt)),
          onAddAmount: _cache[3] || (_cache[3] = (amount, evt) => _ctx.$emit('add-to-cart', amount, evt)),
          style: _normalizeStyle({
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 30,
      })
        }, null, 8 /* PROPS */, ["amount", "packageAmount", "stockQuantity", "style"]))
      : _createCommentVNode("v-if", true)
  ], 36 /* STYLE, NEED_HYDRATION */))
}